module.exports = __webpack_public_path__ + "img/empty_box.1e591099.svg";